import { render, staticRenderFns } from "./font-size-button-toolbox.vue?vue&type=template&id=d5e4ee74&scoped=true&"
import script from "./font-size-button-toolbox.vue?vue&type=script&lang=ts&"
export * from "./font-size-button-toolbox.vue?vue&type=script&lang=ts&"
import style0 from "./font-size-button-toolbox.vue?vue&type=style&index=0&id=d5e4ee74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e4ee74",
  null
  
)

export default component.exports